<template>
  <div id="app">
    <p v-if="error">{{error}}</p>
    <div id="nav">
      <router-link to="/">Ambiesoft</router-link> | 
      <router-link to="/about">About</router-link> | 
      <router-link to="/links">リンク</router-link> | 
      <a href="https://ambiesoft.github.io/webjumper/?target=donate">寄付</a> | 
      <a href="mailto:ambiesoft.trueff@gmail.com">Email</a>
    </div>
    <router-view :appsData="appsData" />
  </div>
</template>

<script>
function sortByDate(ar) {
  ar.sort((a, b) => {
    
    let ai = parseInt(a.date.replace(/\//g, ""), 10);
    let bi = parseInt(b.date.replace(/\//g, ""), 10);

    // console.log(a.date,b.date,ai,bi)
    return bi - ai;
  });
  return ar;
}

import axios from "axios";
export default {
  name: "App",
  data() {
    return {
      appsData: null,
      error: '',
    };
  },
  created() {
    var url = this.$func.getApiJsonUrl()
    console.log('api url:' + url)    
    axios
      .get(url)
      .then(res => (this.appsData = sortByDate(res.data)))
      .catch(err => {
        console.log(err);
        this.error = err;
      });
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
#nav {
  padding-top: 10px;
  padding-left: 20px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
